import React from "react";
import { Clock, Microscope, HeartHandshake, Award } from "lucide-react";
import { differentials, whatsappLink } from "../mock";
import { Button } from "./ui/button";

const iconMap = { Clock, Microscope, HeartHandshake, Award };

const Differentials = () => {
  return (
    <section id="diferenciais" className="brand-grad py-20 md:py-28 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-[#94a7b8]/10 blur-3xl" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <div className="grid lg:grid-cols-3 gap-12">
          <div className="reveal">
            <span className="text-xs font-semibold tracking-widest uppercase text-[#b89a5a]">
              Diferenciais
            </span>
            <div className="gold-line mt-3" />
            <h2 className="font-display font-bold text-3xl md:text-4xl text-white mt-5">
              Por que escolher a Foco Vision
            </h2>
            <p className="text-[#94a7b8] mt-4 leading-relaxed">
              Unimos exceêlência técnica, tecnologia e um atendimento realmente humano
              para cuidar da sua saúde ocular.
            </p>
            <Button
              asChild
              className="mt-7 bg-[#b89a5a] hover:bg-[#a5884b] text-white rounded-full px-7"
            >
              <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                Agende uma consulta
              </a>
            </Button>
          </div>

          <div className="lg:col-span-2 grid sm:grid-cols-2 gap-6">
            {differentials.map((d) => {
              const Icon = iconMap[d.icon];
              return (
                <div
                  key={d.title}
                  className="reveal bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-7 hover:bg-white/10 transition-all duration-300"
                >
                  <div className="w-14 h-14 rounded-xl bg-[#b89a5a]/20 flex items-center justify-center">
                    <Icon className="w-7 h-7 text-[#b89a5a]" />
                  </div>
                  <h3 className="font-display font-semibold text-xl text-white mt-5">
                    {d.title}
                  </h3>
                  <p className="text-[#94a7b8] mt-2 leading-relaxed text-sm">{d.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Differentials;
